/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import React, {memo} from 'react';
import {Typography} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';
import classnames from 'classnames';
import {translate} from '@ion/core/src/locale/locale';
import {dlsTypography} from '../../src/theme/theme';

export interface SelectionHeaderCountProps {
  count: number;
  message: string;
  overrideClassName?: string;
}

export const useStyles = makeStyles((theme) => ({
  selectionsResult : {
    ...dlsTypography('selectionsResult'),
    [theme.breakpoints.down('sm')] : {
      fontSize : '13px',
      padding  : '4px 0 !important'
    }
  }
}));

/**
 * Row count display floated left in a grid selection header.
 *
 * ```typescript
 *
 *   import {SelectionHeaderCount} from '@ion/dls/src/grid/';
 *
 *   <SelectionHeaderCount count={count} />
 *
 * ```
 */
export const SelectionHeaderCount = ({
  count,
  overrideClassName,
  message = 'grids:selectionsHeader.result'
}: SelectionHeaderCountProps) => {
  const classes = useStyles();
  return (
    <Typography component='h4' className={classnames(classes.selectionsResult, overrideClassName)}>
      {translate(message, {count})}
    </Typography>
  );
};

export default memo(SelectionHeaderCount);
